/*
  WebGas: "Leggi di più / Leggi meno" sulla descrizione prodotto (ottobre 2026).

  Markup (sections/main-product.liquid, blocco description):
  <div class="wg-readmore" data-wg-readmore data-lines="8">
    <div class="wg-readmore__content">…descrizione…</div>
    <button class="wg-readmore__toggle" type="button" hidden aria-expanded="false">
      <span class="wg-readmore__more">Leggi di più</span><span class="wg-readmore__less">Leggi meno</span>
    </button>
  </div>

  Chiusa, la descrizione mostra le prime N righe di testo reali (anche con paragrafi ed
  elenchi): il taglio cade esattamente alla fine della riga N e "… Leggi di più" si
  appoggia subito dopo l'ultima parola di quella riga. Se non c'è spazio, il link va a
  destra sulla stessa riga e copre la fine del testo con una sfumatura.
  Se dentro c'è una tabella il taglio avviene prima della tabella.
  Se il testo supera il taglio di meno di 2 righe non si chiude nulla.
*/
(function () {
  // Righe di testo visibili del contenuto: [{top, bottom, right}] in px relativi al contenuto
  function textLines(content) {
    var base = content.getBoundingClientRect();
    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var lines = [];
    var range = document.createRange();
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest('table')) break;
      range.selectNodeContents(node);
      var rects = range.getClientRects();
      for (var i = 0; i < rects.length; i++) {
        var r = rects[i];
        if (r.width < 1 || r.height < 1) continue;
        var top = r.top - base.top, bottom = r.bottom - base.top, right = r.right - base.left;
        var mid = (top + bottom) / 2;
        var line = null;
        for (var j = lines.length - 1; j >= 0 && j >= lines.length - 3; j--) {
          if (mid > lines[j].top && mid < lines[j].bottom) { line = lines[j]; break; }
        }
        if (line) {
          line.top = Math.min(line.top, top);
          line.bottom = Math.max(line.bottom, bottom);
          line.right = Math.max(line.right, right);
        } else {
          lines.push({ top: top, bottom: bottom, right: right });
        }
      }
    }
    return lines;
  }

  function measure(box) {
    var content = box.querySelector('.wg-readmore__content');
    var toggle = box.querySelector('.wg-readmore__toggle');
    var wanted = parseInt(box.getAttribute('data-lines'), 10) || 0;
    if (!content || !toggle || wanted <= 0) return;

    var expanded = box.classList.contains('is-expanded');
    if (expanded) return;
    box.classList.remove('is-collapsible');
    toggle.style.top = toggle.style.left = '';
    toggle.classList.remove('is-right');

    var lines = textLines(content);
    if (lines.length < wanted + 2) {
      box.classList.remove('is-expanded');
      toggle.hidden = true;
      return;
    }

    var last = lines[wanted - 1];
    var limit = Math.ceil(last.bottom);

    box.classList.add('is-collapsible');
    box.style.setProperty('--wg-readmore-height', limit + 'px');
    toggle.hidden = false;
    toggle.setAttribute('aria-expanded', 'false');

    // Posizione del link: subito dopo l'ultima parola della riga N, sulla stessa riga
    var gap = 6;
    var width = content.clientWidth;
    var tw = toggle.offsetWidth;
    var lineHeight = last.bottom - last.top;
    toggle.style.top = Math.round(last.top + (lineHeight - toggle.offsetHeight) / 2) + 'px';
    if (last.right + gap + tw <= width) {
      toggle.style.left = Math.round(last.right + gap) + 'px';
    } else {
      toggle.classList.add('is-right');
    }
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  // Esegue fn alla fine della transizione di altezza (o subito, se il movimento è ridotto)
  function afterTransition(el, fn) {
    if (reduceMotion && reduceMotion.matches) { fn(); return; }
    var done = false;
    function finish(e) {
      if (done || (e && e.propertyName !== 'max-height')) return;
      done = true;
      el.removeEventListener('transitionend', finish);
      fn();
    }
    el.addEventListener('transitionend', finish);
    setTimeout(finish, 600);
  }

  function open(box) {
    var content = box.querySelector('.wg-readmore__content');
    var toggle = box.querySelector('.wg-readmore__toggle');
    content.style.maxHeight = content.clientHeight + 'px';
    box.classList.add('is-expanded', 'is-animating');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.style.top = toggle.style.left = '';
    toggle.classList.remove('is-right');
    void content.offsetHeight;
    content.style.maxHeight = content.scrollHeight + 'px';
    afterTransition(content, function () {
      content.style.maxHeight = '';
      box.classList.remove('is-animating');
    });
  }

  function close(box) {
    var content = box.querySelector('.wg-readmore__content');
    var toggle = box.querySelector('.wg-readmore__toggle');
    var limit = parseFloat(box.style.getPropertyValue('--wg-readmore-height')) || 0;
    content.style.maxHeight = content.scrollHeight + 'px';
    box.classList.add('is-animating');
    void content.offsetHeight;
    box.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
    content.style.maxHeight = limit + 'px';
    if (box.getBoundingClientRect().top < 0) {
      box.scrollIntoView({ block: 'start', behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth' });
    }
    afterTransition(content, function () {
      content.style.maxHeight = '';
      box.classList.remove('is-animating');
      measure(box);
    });
  }

  function init(box) {
    if (box.dataset.wgReadmoreReady) return;
    box.dataset.wgReadmoreReady = '1';
    var toggle = box.querySelector('.wg-readmore__toggle');
    var content = box.querySelector('.wg-readmore__content');
    if (!toggle || !content) return;

    toggle.addEventListener('click', function () {
      if (box.classList.contains('is-animating')) return;
      if (box.classList.contains('is-expanded')) close(box); else open(box);
    });

    // Tastiera: se il focus finisce su un link nella parte nascosta, la descrizione si apre
    content.addEventListener('focusin', function (e) {
      if (!box.classList.contains('is-collapsible') || box.classList.contains('is-expanded')) return;
      var limit = parseFloat(box.style.getPropertyValue('--wg-readmore-height')) || 0;
      var top = e.target.getBoundingClientRect().top - content.getBoundingClientRect().top;
      if (top + 4 > limit) open(box);
    });

    measure(box);
    if ('ResizeObserver' in window) {
      var lastWidth = box.clientWidth;
      new ResizeObserver(function () {
        if (box.clientWidth === lastWidth) return;
        lastWidth = box.clientWidth;
        if (!box.classList.contains('is-expanded') && !box.classList.contains('is-animating')) measure(box);
      }).observe(box);
    }
    // I font arrivano dopo: rimisura quando sono pronti
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(box); });
    window.addEventListener('load', function () { measure(box); });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-wg-readmore]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Editor del tema: la sezione viene ridisegnata
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
